import {ArgValidator, Logger} from 'neo-common';
import {IRealityCheck, RealityCheckTimerExpiredCallback} from './IRealityCheck';
import {IApp} from '../GameEngine/IApp';
import {GameConfigurationBase} from '../GameEngine/GameConfigurationBase';
import {ClientHostDialogRequest} from '../ClientHost/Types';

export abstract class RealityCheckBase implements IRealityCheck {
    private _initialized: boolean;
    protected _app: IApp;
    protected _timerExpiredCallback: RealityCheckTimerExpiredCallback;
    protected _gameConfiguration: GameConfigurationBase;

    constructor() {
        this._initialized = false;
    }

    public initialize(app: IApp, timerExpiredCallback: RealityCheckTimerExpiredCallback): void {
        if (!this._initialized) {
            ArgValidator.ensureIsNotNullOrUndefined(timerExpiredCallback, 'timerExpiredCallback');

            this._app = app;
            this._gameConfiguration = app.gameConfiguration;
            this._timerExpiredCallback = timerExpiredCallback;
            this.doInitialize();
            this._initialized = true;
        }
    }

    public abstract get loggerName(): string;

    public abstract get name(): string;

    public abstract get version(): string;

    protected abstract doInitialize(): void;

    public abstract start(): void;

    public abstract reset(): void;

    protected invokeTimerExpired(request: ClientHostDialogRequest): void {
        if (DEBUG) {
            Logger.debugGroup(this.loggerName, `Timer interval elapsed`);
        }

        this._timerExpiredCallback(request);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/RealityCheck/RealityCheckBase.ts
 **/